<!--- COMPONENTE PCPartidasActivasYRecientesLinea  ---->
<!---
Descripción del componente:
---------------------------
- Incluye una lista con las partidas activas y las finalizadas recientemente de una linea de producción.
TODO

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div>
    <div v-if="trabajarConAsignacionDePartidasPorPedido">
      <PCPartidasActivasYRecientesLineaConAsociacionPedido
        ref="componentPartidasActivasConAsociacionPedido"
        :intervalo-actualizacion-automatica="intervaloActualizacionAutomatica"
        :punto-paletizado-seleccionado="puntoPaletizadoSeleccionado"
        :linea-produccion-seleccionada="lineaProduccionSeleccionada"
        @inicio-carga-datos=" () => {
          $emit('inicioCargaDatos')
        }"
        @fin-carga-datos=" () => {
          $emit('finCargaDatos')
        }"
        @partidas-activas=" (value) => {
          $emit('partidasActivas', value)
        }"
      />
    </div>
    <div v-else>
      <PCPartidasActivasYRecientesLineaSinAsociacionPedido
        ref="componentPartidasActivasSinAsociacionPedido"
        :intervalo-actualizacion-automatica="intervaloActualizacionAutomatica"
        :punto-paletizado-seleccionado="puntoPaletizadoSeleccionado"
        :linea-produccion-seleccionada="lineaProduccionSeleccionada"
        @inicio-carga-datos=" () => {
          $emit('inicioCargaDatos')
        }"
        @fin-carga-datos=" () => {
          $emit('finCargaDatos')
        }"
        @partidas-activas=" (value) => {
          $emit('partidasActivas', value)
        }"
      />
    </div>
  </div>
</template>

<script>
import { Log } from '@/js/common/HIDebuggingSupport';
import PCPartidasActivasYRecientesLineaSinAsociacionPedido from './PCPartidasActivasYRecientesLineaSinAsociacionPedido.vue';
import PCPartidasActivasYRecientesLineaConAsociacionPedido from './PCPartidasActivasYRecientesLineaConAsociacionPedido.vue';

export default {
  name: 'PCPartidasActivasYRecientesLinea',
  components: {
    PCPartidasActivasYRecientesLineaConAsociacionPedido,
    PCPartidasActivasYRecientesLineaSinAsociacionPedido,
  },
  props: {
    intervaloActualizacionAutomatica: { type: Number, default: 0 }, // Se indica en Segundos y actualizara el resumen.
    puntoPaletizadoSeleccionado: { type: Object, default: null }, // Si se establece un punto se filtraran por los puntos de volcado asociados a cada punto de paletizado.
    trabajarConAsignacionDePartidasPorPedido: { type: Boolean, default: false }, // Determina si se trabaja con partidas por pedido o con partidas por tiempo.
    lineaProduccionSeleccionada: { type: Object, default: null },
  },

  emits: [
    'inicioCargaDatos',
    'finCargaDatos',
    'partidasActivas',
  ],

  methods: {
    /**
     * @public
     * @returns {void}
     */
    RestablecerValores() {
      Log(this, this.RestablecerValores.name);
      if (this.trabajarConAsignacionDePartidasPorPedido) {
        this.$refs.componentPartidasActivasConAsociacionPedido.RestablecerValores();
      } else {
        this.$refs.componentPartidasActivasSinAsociacionPedido.RestablecerValores();
      }
    },

    /**
     * @public
     * @returns {void}
     */
    ActualizarDatos(mostrarPrecarga) {
      Log(this, this.ActualizarDatos.name);
      if (this.trabajarConAsignacionDePartidasPorPedido) {
        this.$refs.componentPartidasActivasConAsociacionPedido.ActualizarDatos(mostrarPrecarga);
      } else {
        this.$refs.componentPartidasActivasSinAsociacionPedido.ActualizarDatos(mostrarPrecarga);
      }
    },

    /**
     * @public
     * @returns {void}
     */
    VerMasPartidasDeLaColaDeVolcado(cantidadRegistrosCarga) {
      Log(this, this.VerMasPartidasDeLaColaDeVolcado.name);
      if (this.trabajarConAsignacionDePartidasPorPedido) {
        this.$refs.componentPartidasActivasConAsociacionPedido.VerMasPartidasDeLaColaDeVolcado(cantidadRegistrosCarga);
      } else {
        this.$refs.componentPartidasActivasSinAsociacionPedido.VerMasPartidasDeLaColaDeVolcado(cantidadRegistrosCarga);
      }
    },

    /**
     * @public
     * @returns {void}
     */
    ResetearVolcadosActivos(confirmacion) {
      Log(this, this.ResetearVolcadosActivos.name);
      if (this.trabajarConAsignacionDePartidasPorPedido) {
        this.$refs.componentPartidasActivasConAsociacionPedido.ResetearVolcadosActivos(confirmacion);
      } else {
        this.$refs.componentPartidasActivasSinAsociacionPedido.ResetearVolcadosActivos(confirmacion);
      }
    },
  },
};
</script>
